export const PROP_CHALLENGE_PHASE_VARIANTS = {
    FUNDED: 'funded',
    AUDITION_FIRST: 'auditionFirst',
    AUDITION_NEXT: 'auditionNext',
} as const;

export type PropChallengePhaseVariant =
    (typeof PROP_CHALLENGE_PHASE_VARIANTS)[keyof typeof PROP_CHALLENGE_PHASE_VARIANTS];

export const CHALLENGE_ACTION_TEST_IDS = {
    START_FUNDED: 'start-funded',
    START_AUDITION: 'start-audition',
    CONTINUE_AUDITION: 'continue-audition',
} as const;

export type ChallengeActionTestId = (typeof CHALLENGE_ACTION_TEST_IDS)[keyof typeof CHALLENGE_ACTION_TEST_IDS];
